import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  API_GET_BANK_NAMES,
  API_GET_BANKS,
  API_GET_USER_NGR_BANKS,
  API_GET_USER_USD_BANKS,
} from "../../../config/api";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";

export const getUsersBanks = createAsyncThunk(
  "users/getUsersBanks",
  async ({ callBack, failed, currency, user_id }, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "GET",
        path: `${
          currency === "USD" ? API_GET_USER_USD_BANKS : API_GET_USER_NGR_BANKS
        }${user_id}`,
      });
      callBack(response?.data?.data || response?.data);
      return response?.data?.data || response?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      failed();
      throw error;
    }
  }
);
